module.exports = __webpack_public_path__ + "img/PH.e109cf95.svg";